<div class="space-y-6">
  @if (company?.is_member) {
    <div hlmAlert>
      <ng-icon name="lucideUsers" />
      <p hlmAlertTitle>Gutschein-Shop von {{ company?.member_of_company_name }}</p>
      <p hlmAlertDescription>
        Als Mitglied integrierst du den Shop deines Netzwerks auf deiner Website. Kunden können
        darüber Gutscheine kaufen, die bei allen Mitgliedern des Netzwerks einlösbar sind.
      </p>
    </div>
  }

  <!-- ── Detected integration (plugin loaded or link followed on the website) ── -->
  @if (company?.integration_detected_at) {
    <div hlmAlert>
      <ng-icon name="lucideCircleCheck" />
      <p hlmAlertTitle>Integration erkannt</p>
      <p hlmAlertDescription>
        Seit dem {{ company!.integration_detected_at + 'Z' | date: 'dd.MM.yyyy' }} ist dein
        Gutschein-Shop auf deiner Website zu finden ({{ detectedVia }} auf
        {{ company!.integration_url }}).
      </p>
    </div>
  } @else {
    <div hlmAlert>
      <ng-icon name="lucideRadar" />
      <p hlmAlertTitle>Noch keine Integration erkannt</p>
      <p hlmAlertDescription>
        Sobald das Plugin auf deiner Website lädt oder jemand über einen Link von dort zu deinem
        Shop kommt, erkennen wir das automatisch und haken die Aufgabe ab.
        @if (!company?.website) {
          Dafür muss deine Website hinterlegt sein.
        }
      </p>
    </div>
  }

  <!-- ── Option 1: link ── -->
  <section hlmCard>
    <div hlmCardHeader>
      <h2 hlmCardTitle>Link in deine Website einfügen</h2>
      <p hlmCardDescription>
        Der einfachste Weg: Ergänze deine Navigation oder einen Button mit einem Link zu deiner
        Schenkwerk-Seite. Kein Code nötig – URL kopieren und als Linkziel eintragen.
      </p>
      <div hlmCardAction>
        <span hlmBadge variant="secondary">Einfachste Option</span>
      </div>
    </div>

    <div hlmCardContent>
      <div hlmItem variant="muted">
        <div hlmItemContent class="min-w-0">
          <code class="truncate font-mono text-sm">{{ storefrontUrl }}</code>
        </div>
        <div hlmItemActions>
          <button hlmBtn variant="outline" size="sm" (click)="copyUrl()">
            <ng-icon [name]="copiedKey === 'url' ? 'lucideCheck' : 'lucideCopy'" />
            {{ copiedKey === 'url' ? 'Kopiert' : 'Kopieren' }}
          </button>
        </div>
      </div>
    </div>
  </section>

  <!-- ── Option 2: plugin (floating button or inline) ── -->
  <app-embed-code
    [storeId]="effectiveStoreId"
    [website]="company?.website"
    [primaryColor]="company?.voucher_app_primary_color"
    [textColor]="company?.voucher_app_text_color"
    [shopTitle]="company?.voucher_app_title"
    [freeAmount]="company?.money_voucher_enabled !== false"
    [fixedAmounts]="!!company?.fixed_voucher_amounts_enabled"
    [products]="!!company?.voucher_products_enabled" />

  <!-- ── Tutorials ── -->
  <section hlmCard>
    <div hlmCardHeader>
      <h2 hlmCardTitle>Tutorials – Schritt für Schritt integrieren</h2>
      <p hlmCardDescription>
        Plattformspezifische Anleitungen, wie du die Gutschein-App auf deiner Website einbindest.
      </p>
    </div>

    <div hlmCardContent class="grid gap-3 sm:grid-cols-2">
      @for (tutorial of tutorials; track tutorial.name) {
        <a hlmItem variant="outline" [href]="tutorial.url" target="_blank" rel="noopener">
          <div hlmItemContent>
            <span hlmItemTitle>{{ tutorial.name }}</span>
            <span hlmItemDescription>{{ tutorial.hint }}</span>
          </div>
          <div hlmItemActions>
            <ng-icon name="lucideExternalLink" class="text-muted-foreground" />
          </div>
        </a>
      }
    </div>
  </section>
</div>
